export const filterData = [
  {
    id: "period",
    label: "Date",
    type: "single",
    options: [
      { label: "Today", value: 1 },
      { label: "This week", value: 2 },
      { label: "This month", value: 3 },
      { label: "Last week", value: 4 },
      { label: "Last month", value: 5 },
      { label: "Last 3 month", value: 6 },
    ],
  },
  {
    id: "type",
    label: "Activities",
    type: "multi",
    options: [
      { label: "All", value: 0 },
      // { label: "Calls", value: 8 },
      { label: "Chats", value: 7 },
    ],
  },
];
